module.exports = __webpack_public_path__ + "img/carousel.b99dd165.png";